var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHerbal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155,
    height: 136,
    viewBox: "0 0 155 136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#777",
    strokeWidth: 6,
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M0 68h138M115 130c0-7.547-19.475-10-43.501-10C47.473 120 28 122.453 28 130h87z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M102.48 121.688C124.785 109.858 140 86.224 140 59H0c0 27.98 16.208 51.522 39.53 63l62.95-.312zM124 25l6 6"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M105.946 59L134 28.07 127.188 21 87 59M40 107c2.776 1.608 5.778 2.986 9 4M17 84s5.181 10.376 15 19"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 16.5,
    r: 10.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 .192s-16.795 50.807-46.483 42.99l19.084-21.285-24.497 16S21.878-3.136 87 .191zM36 38s-4.947 9.597-21 10"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerbal);
export default __webpack_public_path__ + "static/media/herbal.ef87b6846321b6fb5bbfd2472565885f.svg";
export { ForwardRef as ReactComponent };